<template></template>
<script>
  export default {
    name: 'Zap',
    mounted() {
      this.$router.push('/' + this.empresa.dominio_delivery);
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      }
    }
  }
</script>
